export function isNavItemActive(pathname, item) {
  const { to, match = "prefix", isActive } = item

  if (typeof isActive === "function") {
    return isActive(pathname, to)
  }

  if (match === "exact") {
    return pathname === to
  }

  return pathname === to || pathname.startsWith(`${to}/`)
}
